import { render, staticRenderFns } from "./DynamicEditButton.vue?vue&type=template&id=dbfeb320&"
import script from "./DynamicEditButton.vue?vue&type=script&lang=js&"
export * from "./DynamicEditButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports